<template lang="pug">
  div#appAnalise
    vue-progress-bar
    div(
      v-if="loader.status"
      v-loading="loader.status",
      :element-loading-text="loader.text",
      v-loading.fullscreen.lock="true"
    )
    header
      main-header
    main.container
      side-menu-lazy(:items="items")
      .content
        .container-router(:body-style="{ width: '100%' }" shadow="hover")
          router-view
          router-view(name="filtro")
          router-view(name="listagem")
</template>

<script>
import { mapState } from 'vuex'
import MainHeader from '@/components/MainHeader'
import SideMenuLazy from '@/components/SideMenuLazy'
import menus from './menu'

export default {
  components: {
    MainHeader,
    SideMenuLazy
  },

  data () {
    return {
      items: []
    }
  },

  created () {
    this.items = menus
  },

  computed: {
    ...mapState({
      loader: state => state.loader
    })
  },

  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

* {
  box-sizing: border-box;
  font-family: 'Ubuntu', sans-serif;
}

header {
  width: 100%;
  z-index: 5;
}

main.modal-open {
  overflow-x: hidden;
  position: relative;
  z-index: 8;
}

.container-router {
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  width: 100%;
  min-height: 100%;
}

#appAnalise {
  width: 100%;
  height: 100%;

  /deep/ h1,
  /deep/ h2,
  /deep/ h3,
  /deep/ h4,
  /deep/ h5,
  /deep/ p {
    color: #424242;
  }

  /deep/ p {
    margin: 0 0 10px;
  }

  /deep/ main {
    width: 100%;
  }

  .container {
    display: flex;
    border-radius: 12px;
    width: 100%;
    min-height: 100%;
  }

  .container-router {
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    width: 100%;
    min-height: 100%;
  }

  .content {
    width: 100%;
    padding: 20px 30px;
    overflow-y: hidden;
  }

  @media (max-width: 780px) {
   .content {
    padding: 10px 10px;
   }
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/MainPage.vue